module.exports = __webpack_public_path__ + "static/media/1017059.d712d9be.png";